import React from 'react';
import ReactApexChart from 'react-apexcharts';
import './graficas.css'
import { Typography, makeStyles } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

const generateColors = (count) => {
  const baseColors = [
    "#775DD0", "#FF5733", "#FFA933", "#33FF57", "#33AFFF",
    "#FF33A8", "#3357FF", "#33FFA8", "#FF33AF", "#A833FF",
    "#33FFC3", "#FF33C3", "#33C3FF"
  ];
  const colors = [];
  for (let i = 0; i < count; i++) {
    colors.push(baseColors[i % baseColors.length]);
  }
  return colors;
};
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(2), 
    width:'20%'
  },
  text: {
    whiteSpace: 'nowrap', 
    textOverflow: 'ellipsis', 
  },
}));
const ChartComponent = ({ data, categories, height, preguntas }) => {
  const classes = useStyles();
  const customColors = generateColors(categories.length);
  const options = {
    series: [
      {
        data: data.map((value, index) => ({ x: categories[index], y: value })),
      }
    ],
    chart: {
      height: height || 350,
      type: "bar",
      events: {
        click: function (chart, w, e) {

        }
      }
    },
    colors: customColors || [
      "#775DD0",
      "#FF5733",
      "#FFA933",
      "#33FF57",
      "#33AFFF",
      "#FF33A8",
      "#3357FF",
      "#33FFA8",
      "#FF33AF",
      "#A833FF",
      "#33FFC3",
      "#FF33C3",
      "#33C3FF"
    ],
    plotOptions: {
      bar: {
        columnWidth: "37.5%",
        distributed: true,
        borderRadius: 17
      }
    },
    dataLabels: {
      enabled: false
    },
    legend: {
      show: false
    }, xaxis: {
      labels: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    }, tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const color = customColors[dataPointIndex];
        const label = categories[dataPointIndex];
        //   const value = porcentajes[dataPointIndex]; 

        return (
          '<div className="custom-tooltip" style="width: 155px; font-size: 12px; border-radius: 10%; text-align: center;">' +
          '<div className="tooltip-label" style="background-color: ' +
          color +
          '; color: white; padding: 5px 0;">' +
          label +
          '</div>' +
          '<div className="tooltip-content" style="display: flex; align-items: center; background-color:#dadde9; padding: 5px 10px; background-color:white">' +
          '<div className="sales-circle" style="background-color: ' +
          color +
          '; border-radius: 50%; width: 10px; height: 10px;"></div>' +
          '<div className="sales-value" style="font-weight: bold; margin-left: 5px;">' +
          // value + '%' +
          '</div>' +
          '</div>' +
          '</div>'
        );
      },
    },
    toolbar: {
      show: false,
    },
  };

  return (
    <>
       <Typography>{preguntas}</Typography>
    <div id="chart" className={classes.root}>
   
      <ReactApexChart options={options} series={options.series} type="bar" height={270} width={650} className="custom-apex-chart" />
      <div className="legend" >
        {categories.map((category, index) => (
          <div key={index} className={classes.legendItem}>
            <FiberManualRecordIcon style={{ color: customColors[index] }} />
            <Typography className={classes.text}>{category}-{data[index]}</Typography>
          </div>
        ))}
      </div>
    </div>
    </>
  );
}



export default ChartComponent;